const columns = [
  {
    id: "id",
    label: "ID",
    align: "left",
    disablePadding: false,
    sort: true,
  },
  {
    id: "name",
    label: "NOMBRE Y APELLIDO",
    align: "left",
    disablePadding: false,
    sort: false,
  },
  {
    id: "documentNumber",
    label: "DOCUMENTO",
    align: "left",
    disablePadding: false,
    sort: false,
  },
  {
    id: "type",
    label: "TIPO",
    align: "left",
    disablePadding: false,
    sort: true,
  },
  {
    id: "content",
    label: "CONTENIDO",
    align: "left",
    disablePadding: false,
    sort: false,
  },
  {
    id: "diagnosis",
    label: "DIAGNÓSTICO",
    align: "left",
    disablePadding: false,
    sort: false,
  },
  {
    id: "date",
    label: "EMISIÓN",
    align: "left",
    disablePadding: false,
    sort: true,
  },
  {
    id: "status",
    label: "ESTADO",
    align: "center",
    disablePadding: false,
    sort: false,
  },{
    id: "actions",
    label: "ACCIONES",
    align: "center",
    disablePadding: false,
    sort: false,
  },
];

export default columns;
